export default __webpack_public_path__ + "static/media/smallIntermission3.3ec7f43c.mp3";